import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { TableCell, TableRow, Typography } from "@mui/material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import { Visibility } from "@mui/icons-material";
import Subscription from "./Subscription";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";

export enum FieldType {
  Number,
  String,
}

export type Field = {
  key: string;
  type: FieldType;
  editable: boolean;
  hidden: boolean;
  value: any;
};

export enum VenueFields {
  id = "id",
  name = "name",
}

export default class Venue extends DatabaseModel implements DatabaseModelElement {
  // fields: Field[] = [
  //   { key: "id", type: FieldType.Number, editable: false, hidden: false, value: this.id },
  //   { key: "name", type: FieldType.String, editable: true, hidden: false, value: this.name },
  //   { key: "address", type: FieldType.String, editable: true, hidden: false, value: this.address },
  // ];
  static modelName = "Venue";

  constructor(
    public id: number = 0,
    public name: string = "",
    public address: string = "",
    public city: string = "",
    public postal_code: string = "",
    public country: string = "",
    public phone_number: string = "",
    public email_address: string = "",
    public website: string = "",
    public vat_number: string = "",
    public coc_number: string = "",
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = null,
    public subscriptions: Subscription[] = [],
    public gateways_count: number | null = null
  ) {
    super();
  }

  static CreateModel(model: any): Venue {
    return new Venue(
      model.id,
      model.name,
      model.address,
      model.city,
      model.postal_code,
      model.country,
      model.phone_number,
      model.email_address,
      model.website,
      model.vat_number,
      model.coc_number,
      new Date(model.created_at),
      new Date(model.updated_at),
      model.deleted_at ? new Date(model.deleted_at) : null,
      model.subs_subscriptions
        ? model.subs_subscriptions.map((subscription: object) => Subscription.CreateModel(subscription))
        : [],
      model.gateways_count
    );
  }

  hasActiveSubscription(): boolean {
    return this.subscriptions.some((subscription) => subscription.isActive());
  }

  tableRow() {
    return (
      <TableRow>
        <AuthenticationWrapper child={<TableCell>{this.id}</TableCell>} permissionKey={"venue.id"} />

        <TableCell>{this.name}</TableCell>
        <TableCell>{this.city}</TableCell>
        <TableCell>
          <Typography>{this.hasActiveSubscription() ? "Active" : "Not active"}</Typography>
        </TableCell>
        <TableCell>
          <Link to={Venue.editPath(this.id)}>
            <Visibility />
          </Link>
        </TableCell>
      </TableRow>
    );
  }
}
